import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-deep" data-id="element-98" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-99" data-mp="3ggarlxr3gh6i">
        <h3 className="font-display text-2xl text-white" data-id="element-100" data-mp="32nuh6bvv5gvk">Sailing Lesson Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-101" data-mp="32m1bayt2r0om">
          The Any-Wind Lesson System: one lesson, three winds, and a plan for
          the day whatever the flag says.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/75" data-id="element-102" data-mp="3ud7h9vvh7slt">
          <a href="mailto:help@iclcollective.com" className="transition-colors duration-150 hover:text-white hover:underline" data-id="element-103" data-mp="36d08okdmdj3">help@iclcollective.com</a>
        </div>
        <p className="mx-auto mt-7 max-w-2xl border-t border-white/15 pt-5 text-xs leading-relaxed text-white/55" data-id="element-104" data-mp="3qbvojhhb2r9e">
          Sailing Lesson Ready is an educational resource for trained sailing
          instructors and coaches. It does not teach sailing from scratch and
          does not replace instructor certification, your national program or
          your club&apos;s rules. Always follow your program&apos;s wind
          limits, ratios, safety boat and life jacket requirements: the pack
          never sets a wind limit and never promises that you can always go
          out. Capsize, rudderless and crew overboard practice belong in a
          supervised area with a safety boat. Racing rules are referred to as
          the current Racing Rules of Sailing and explained in our own words.
          Not affiliated with or endorsed by any national sailing authority,
          club or class association. © Sailing Lesson Ready 2026. All rights
          reserved.
        </p>
      </div>
    </footer>;
}